import { assert } from '../../../lib/assert-sidecar'
import { common } from '../../../main/common-sidecar'
import { clickEater } from '../../../uiParts/clickEater-sidecar'
import { stevieTexts2 } from '../../../uiParts/stevieTexts2-sidecar'
import { chessCamera } from '../chessCamera-sidecar'
import { chessLayers } from '../chessLayers-sidecar'
import { chessFonts } from './chessFonts-sidecar'
import type { IChessUiCanvas } from './chessUiCanvas'
import { chessUiCanvas } from './chessUiCanvas-sidecar'
import { chessUiGButtons } from './chessUiGButtons-sidecar'
import { chessUiGraphicsUtils } from './chessUiGraphicsUtils-sidecar'

interface IChessUiPrompt extends IChessUiCanvas {
  textTitle: string
  textDesc: string
  onOk: (val: string) => void
  htmlInput: HTMLInputElement
}
let _obj: IChessUiPrompt | null = null
export function get() {
  if (!_obj) {
    _obj = create()
    setOpen(false)
    render()
  }
  return _obj
}

const create = () => {
  let tw = 600
  let th = 300

  let canvas = chessUiCanvas.create(tw, th, chessLayers.getLayers().uiMessage)
  canvas.autoOffset = false

  var htmlInput = document.createElement('input')
  htmlInput.type = 'text'
  htmlInput.style.position = 'absolute'
  htmlInput.style.left = '0px'
  htmlInput.style.top = '0px'
  let phaserRoot = document.getElementById('phaser-root')
  assert.notNil(phaserRoot)
  phaserRoot.appendChild(htmlInput)

  let obj: IChessUiPrompt = chessUiCanvas.assign<IChessUiPrompt>(canvas, {
    textTitle: 'Title',
    textDesc: 'Desc',
    onOk: () => {},
    htmlInput,
  })

  const onOk = () => {
    let val = get().htmlInput.value + ''
    get().onOk(val)
    setOpen(false)
  }

  // https://www.w3schools.com/howto/howto_js_trigger_button_enter.asp
  htmlInput.addEventListener('keyup', (ev) => {
    // Number 13 is the "Enter" key on the keyboard
    if (ev.code === 'Enter' || ev.code === 'NumpadEnter' || ev.keyCode === 13) {
      // Cancel the default action, if needed
      ev.preventDefault()
      onOk()
    }
  })

  obj.buttons = [chessUiGButtons.create('Ok', 50, 50, onOk)]

  return obj
}

export const setText = (text: string, desc: string, val: string) => {
  let obj = get()
  obj.textTitle = text
  obj.textDesc = desc
  obj.htmlInput.value = val
}

const render = () => {
  let obj = get()
  let g = obj.graphics

  chessUiCanvas.clear(obj)

  let addText = (text: string, x: number, y: number) => {
    let _text = stevieTexts2.create(chessFonts.get().f, x, y, obj.layer)
    stevieTexts2.setText(_text, text)
    stevieTexts2.setScale(_text, 0.4)
    obj.texts.push(_text)
    return _text
  }

  g.clear()

  let gb = chessCamera.getGameBounds()

  g.fillStyle(0x222222, 0.67)
  g.fillRect(0, 0, gb.width, gb.height)

  let w = obj.targetWidth
  let h = obj.targetHeight

  let x = (gb.width - w) / 2
  let y = (gb.height - h) / 2

  chessUiGraphicsUtils.bevelPanel(g, x, y, w, h)

  let title = addText(obj.textTitle, x + 6, y)
  stevieTexts2.setScale(title, 0.6)
  stevieTexts2.setWrapWidth(title, 9999)

  let textDesc = addText(obj.textDesc, x + 6 + 20, y + 40)
  stevieTexts2.setWrapWidth(textDesc, obj.targetWidth - 50)

  y += 100

  let mz = chessCamera.get().mobileZoom
  let inputW = 150 * mz
  let inputH = 40 * mz
  let inputFont = 26 * mz

  let gb2 = chessCamera.getGameBoundsRaw()
  let x2 = gb2.width / 2 - inputW / 2
  let y2 = gb2.height / 2 - inputH / 2 - 10

  let adjX = x2 //(x + 40) * mz
  let adjY = y2 // y * mz

  let style = obj.htmlInput.style
  style.left = adjX + 'px'
  // // style.right = adjX + inputW + 'px'
  style.width = inputW + 'px'
  style.top = adjY + 'px'
  // // style.bottom = adjY + inputH + 'px'
  style.height = inputH + 'px'
  style.fontSize = inputFont + 'px'

  // style.left = '10px'
  // style.top = '0px'

  y -= 100

  x += 20
  y += h - 60
  obj.buttons[0].x = x
  obj.buttons[0].y = y

  chessUiCanvas.render(obj)
}

export const setOpen = (isOpen: boolean, onOk = (val: string) => {}) => {
  let obj = get()
  chessUiCanvas.setOpen(obj, isOpen)
  obj.onOk = onOk

  if (isOpen) {
    update()
    setTimeout(() => {
      obj.htmlInput.focus()
    }, 1)
  }
  obj.htmlInput.style.display = isOpen ? '' : 'none'
}

export const update = () => {
  let obj = get()

  if (obj.isOpen) {
    chessUiCanvas.update(obj)
    render()
    clickEater.tempEatCursor()
  } else {
    chessUiCanvas.clear(obj)
  }
}
